import { copyArray } from 'utils/Global';
import EVolumetricLayerDispense from './EVolumetricLayerDispense';
import EVolumetricLayerType, { EVolumetricLayerTarget } from './EVolumetricLayerType';

interface IVolumetricLayerKey {
  dispense: EVolumetricLayerDispense;
  type: EVolumetricLayerType;
  layersIDs: number[];
  targetDropNumber?: number;
}
export class VolumetricLayerKey {
  readonly Dispense: EVolumetricLayerDispense;
  readonly Type: EVolumetricLayerType;
  readonly Target: EVolumetricLayerTarget;
  readonly TargetDropNumber?: number;

  isLayerIDSorted = false;
  layerIDs: number[] = [];
  get LayerIDs(): number[] {
    if (this.isLayerIDSorted == false) {
      this.layerIDs.sort((a, b) => a - b);
    }

    return this.layerIDs;
  }

  constructor(layerKey: IVolumetricLayerKey) {
    if (layerKey.targetDropNumber === null) {
      this.Target = EVolumetricLayerTarget.Well;
    } else {
      this.Target = EVolumetricLayerTarget.Drop;
    }
    this.TargetDropNumber = layerKey.targetDropNumber;
    this.Dispense = layerKey.dispense;
    this.Type = layerKey.type;
    this.layerIDs = layerKey.layersIDs;
  }

  public get LayerIDString() {
    return this.LayerIDs.map((layerID) => layerID.toString());
  }

  public get KeyText(): string {
    {
      const keyTexts: any = new Object[3 + this.LayerIDs.length]();
      keyTexts[0] = this.GetTargetText();
      keyTexts[1] = this.Dispense;
      keyTexts[2] = this.Type;
      copyArray(this.LayerIDs, 0, keyTexts, 3, this.LayerIDs.length);

      return keyTexts.map((keyText) => keyText.ToString()).toString();
    }
  }

  parseKeyText(keyText: string) {
    const keyTexts: string[] = keyText.split(',');
    let target: EVolumetricLayerTarget;
    let targetDropNumber: EVolumetricLayerTarget;
    this.ParseTargetText(keyTexts[0], target, targetDropNumber);
    // Todo: Below two values not converted properly
    let dispense: EVolumetricLayerDispense.Manual;
    const type: EVolumetricLayerType = EVolumetricLayerType.Volumetric;

    const layersIDs: number[] = keyTexts.slice(3).map((layerID) => parseInt(layerID));
    return new VolumetricLayerKey({ dispense, type, layersIDs, targetDropNumber });
  }

  GetTargetText(this: any): string {
    let text: string = this.Target.ToString();
    // TODO: Don't like the underscore.  It's also used in RockMaker.Drivers.Dispensing.Tecan.Logging.LogVariable!
    if (this.Target == EVolumetricLayerTarget.Drop) {
      text += '_' + this.TargetDropNumber;
    }
    return text;
  }

  ParseTargetText(
    text: string,
    target: EVolumetricLayerTarget,
    targetDropNumber?: number,
  ) {
    if (text == EVolumetricLayerTarget.Well.toString()) {
      target = EVolumetricLayerTarget.Well;
      targetDropNumber = null;
      return;
    }

    //   // TODO: Don't like the underscore.  It's also used in RockMaker.Drivers.Dispensing.Tecan.Logging.LogVariable!
    const dropTarget: string = EVolumetricLayerTarget.Drop.toString() + '_';
    if (text.startsWith(dropTarget)) {
      target = EVolumetricLayerTarget.Drop;
      targetDropNumber = parseInt(text.substring(dropTarget.length));
      return;
    }
  }

  Equals(obj) {
    const other: VolumetricLayerKey = obj as VolumetricLayerKey;

    if (other == null) {
      return false;
    }

    if (this.Dispense != other.Dispense) {
      return false;
    }

    if (this.Type != other.Type) {
      return false;
    }

    if (this.LayerIDs.length != other.LayerIDs.length) {
      return false;
    }

    for (let i = 0; i < this.LayerIDs.length; i++) {
      if (this.LayerIDs[i] != other.LayerIDs[i]) {
        return false;
      }
    }

    return true;
  }

  CompareTo(this: any, other: VolumetricLayerKey): number {
    if (this.Dispense != other.Dispense) {
      return this.Dispense == EVolumetricLayerDispense.Manual ? -1 : 1;
    }

    if (this.Type != other.Type) {
      return this.Type == EVolumetricLayerType.Concentration ? -1 : 1;
    }

    for (let i = 0; i < this.LayerIDs.Length && i < other.LayerIDs.length; i++) {
      if (this.LayerIDs[i] == other.LayerIDs[i]) {
        continue;
      }
      return this.LayerIDs[i] < other.LayerIDs[i] ? -1 : 1;
    }
  }
}
